import React from 'react';
import Portal from './Portal';

interface ValidationPopupProps {
  message: string;
  onClose: () => void;
  onConfirm: () => void;
  type: 'add' | 'edit';
}

const ValidationPopup: React.FC<ValidationPopupProps> = ({ message, onClose, onConfirm, type }) => {
  return (
    <Portal>
      <div className="modal show d-block" style={{ backgroundColor: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', zIndex: 1100 }} tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
            <div className="modal-header border-bottom-0 pt-4 px-4">
              <div className="d-flex align-items-center">
                <div className="bg-warning bg-opacity-10 p-2 rounded-3 me-3">
                  <i className="bi bi-exclamation-triangle text-warning fs-5"></i>
                </div>
                <h5 className="modal-title fw-bold mb-0">Item Validation</h5>
              </div>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body px-4 pb-4">
              <p className="text-muted mb-0">{message}</p>
            </div>
            <div className="modal-footer border-top-0 px-4 pb-4 pt-0">
              <div className="d-flex gap-2 w-100">
                <button className="btn btn-light flex-grow-1" onClick={onClose}>
                  {type === 'add' ? 'Keep Editing' : 'Go Back'}
                </button>
                <button className="btn btn-primary flex-grow-1 fw-bold" onClick={onConfirm}>
                  {type === 'add' ? 'Add Anyway' : 'Edit Anyway'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default ValidationPopup;
